import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import startCase from 'lodash/startCase';
import { TypeUtils } from '@vectord/utils';

function FieldErrors({
  className,
  errors,
  name,
  prefixName = true,
  ...remainingProps
}) {
  const fieldErrors = errors && errors[name];

  if (errors?.length > 0 && TypeUtils.isString(errors)) {
    return (
      <li className={classNames('h6 danger p-l-xs', className)}>{errors}</li>
    );
  } else if (fieldErrors?.length > 0 && TypeUtils.isArray(fieldErrors)) {
    return (
      <ul
        className={classNames('h6 danger p-l-xs', className)}
        {...remainingProps}
      >
        {fieldErrors.map((errorMessage, index) => (
          <li key={index}>
            {prefixName ? (
              <>
                {startCase(name)} - {errorMessage}
              </>
            ) : (
              <>{errorMessage}</>
            )}
          </li>
        ))}
      </ul>
    );
  } else {
    return null;
  }
}

FieldErrors.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  prefixName: PropTypes.bool,
  errors: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
    PropTypes.string,
  ]),
};

export default FieldErrors;
